<div class="d-flex justify-content-end">
  <svg-icon [src]="'assets/icons/'+ (!this.data.isvisible ? 'no-' : '') +'visible.svg'"
            class="cursor-pointer"
            matTooltip="Masquer ou afficher"
            (click)="toggleVisibility()"></svg-icon>
  <svg-icon src="assets/icons/edit-action.svg" class="ml-px-8 cursor-pointer"
    matTooltip="Modifier"
            (click)="openAddServiceAffectationDialog()" ></svg-icon>
</div>
